export default {
    state: {
        emailContext: {
            fileSelectionUrl: null
        },
        selectedMailbox: null
    },

    mutations: {
        SET_FILE_SELECTION_URL: (state, payload) => state.emailContext.fileSelectionUrl = payload,
        SET_SELECTED_MAILBOX: (state, payload) => state.selectedMailbox = payload,
    },

    actions: {
        UPDATE_FILE_SELECTION_URL_FOR_CONTEXT: (context, payload) => {
            context.commit("SET_FILE_SELECTION_URL", payload);
        },
        UPDATE_SELECTED_MAILBOX: (context, payload) => {
            context.commit("SET_SELECTED_MAILBOX", payload);
        }
    },

    getters: {
        mutableEmailContext: state => state.emailContext,
        mutableSelectedMailbox: state => state.selectedMailbox,
    }

};
